<div *ngIf="!templateSelected">
	<div class="d-flex">
		<div class="h3 m-2">Marketing Templates</div>

		<div class="d-flex my-2 ms-auto">
			<p-button *ngIf="!templateSelected" pRipple styleClass="p-button-raised  ms-2 my-2" (click)="templateNew()">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</div>

	<div class="card">
		<p-table
			#dt
			styleClass="p-datatable-responsive-demo"
			[value]="templateList"
			[loading]="!templateList"
			[globalFilterFields]="app.keys(templateList)"
			[scrollable]="true"
			[rows]="100"
			scrollHeight="700px"
			[virtualScroll]="true"
			[virtualRowHeight]="40"
		>
			<ng-template pTemplate="caption">
				<div class="table-header d-flex">
					<div class="flex-grow-1">
						<span class="p-float-label p-input-icon-left m-2 w-100">
							<i class="pi pi-search"></i>
							<input
								pInputText
								class="w-100"
								id="globalSearch"
								name="globalSearch"
								style="width: 100%"
								type="text"
								(input)="dt.filterGlobal($event.target.value, 'contains')"
							/>
							<label for="globalSearch">Search...</label>
						</span>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="name">
						<div class="d-flex justify-content-between">
							<div>Name</div>
							<div>
								<p-sortIcon field="name"></p-sortIcon>
							</div>
						</div>
					</th>
					<th pSortableColumn="created">
						<div class="d-flex justify-content-between">
							<div>Created</div>
							<div>
								<p-sortIcon field="created"></p-sortIcon>
							</div>
						</div>
					</th>
					<th pSortableColumn="description">
						<div class="d-flex justify-content-between">
							<div>Description</div>
							<div>
								<p-sortIcon field="description"></p-sortIcon>
							</div>
						</div>
					</th>
					<th>Stats</th>
				</tr>
			</ng-template>
			<ng-template let-rec pTemplate="body">
				<tr (click)="templateSelected = rec">
					<td>
						{{ rec.name }}
					</td>
					<td>
						{{ moment(rec.created).format("l LT") }}
					</td>
					<td class="overflow-wrap">
						{{ rec.description }}
					</td>
					<td>
						<div class="d-flex flex-column">
							<div>Sends: {{ rec.sentCount }}</div>
							<div>Opens: {{ rec.openCount }}</div>
							<div *ngIf="rec.lastSend">Last Sent: {{ moment(rec.lastSend).format("l LT") }}</div>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<app-template-setup *ngIf="templateSelected" #templateSetup [(template)]="templateSelected" [(templateList)]="templateList"></app-template-setup>
